var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('span', {
    class: _setup.YM_HIDE_CONTENT
  }, [_vm._v("\n  " + _vm._s(_setup.output) + "\n")]);
};
var staticRenderFns = [];
export { render, staticRenderFns };